import { FC } from "react";
import { AxiosError } from "axios";
import { ReportApi } from "../../../api/ReportApi";
import Logger from "../../../utils/Logger";

interface ExportButtonProps {
  setErrorStatus: (error: AxiosError | { message?: string } | string) => void;
  setErrorType: (type: string) => void;
  setLoading: (loading: boolean) => void;
}

const ExportButton: FC<ExportButtonProps> = ({
  setErrorType,
  setErrorStatus,
  setLoading,
}) => {
  const handleExportCSV = async () => {
    try {
      setLoading(true);
      Logger.info("Starting CSV export process", ["ExportButton"]);

      const { data, filename } = await ReportApi.fetchExportCSV();

      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Logger.info("CSV export completed successfully", ["ExportButton"]);
    } catch (error) {
      console.error("Error exporting CSV:", error);
      setErrorType("exportCSV");
      Logger.error("Error exporting CSV", error, ["ExportButton"]);
      setErrorStatus(error as AxiosError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center">
      <button
        type="button"
        id="export-button"
        aria-label="Export Sample Data"
        className="flex m-4 inline-block items-center text-blue px-4"
        onClick={() => {
          handleExportCSV();
        }}
        title="Export facility details for all map"
      >
        <div className="icon-cloud_download text-blue text-3xl pr-2" />
        <span
          className="flex pl-[8px] text-[16px] text-center "
          role="menuitem"
          tabIndex={0}
        >
          Export All
        </span>
      </button>
    </div>
  );
};

export default ExportButton;
